<template>
  <section class="content">
    <box >
      <div slot="body">
        <div class="row">
          <div class="col-md-6">
              <h4>Descrição</h4>
              <input v-model="pergunta.descricao" type="text" class="form-control">
              <label v-if="pergunta.descricao === ''">*Campo Obrigatório</label>
          </div>
          <div class="col-md-3">
              <h4>Posição</h4>
              <input type="number" class="form-control" v-model="pergunta.posicao">
          </div>
          <div class="col-md-3">
              <h4>Tipo</h4>
              <label class="radio-inline"><input type="radio" v-model="pergunta.tipo" value="text" checked>Text</label>
              <label class="radio-inline"><input type="radio" v-model="pergunta.tipo" value="options">Options</label>
          </div>
      </div><br>
      <div v-show="pergunta.tipo === 'options'" v-for="(op, index) in pergunta.opcoes">
        <div class="row">
          <div class="col-md-3">
            <h4>Opção {{index + 1}}</h4>
            <input type="text" class="form-control" v-model="op.opcao">
          </div>
          <div class="col-md-3" style="margin-top: 3em; cursor: pointer;">
            <a @click="adicionarOpcao" v-if="index === pergunta.opcoes.length - 1"><i class="fa fa-plus-circle" aria-hidden="true">Adicionar Opção</i></a>
            <a @click="removerOpcao(index)" v-else><i class="fa fa-times" aria-hidden="true">Remover Opção</i></a>
          </div>
        </div>
      </div>
      <br>
      <div class="row">
        <div class="col-md-1">
          <h4>Ativo</h4>
            <toggle-button 
              v-model="pergunta.ativo"
              :color="color" 
              :sync="true" />
        </div>
      </div><br>
      <br><br>
      <router-link class="pageLink" to="/perguntas">
              <button class="btn btn-danger" >Cancelar</button>
      </router-link>
      <button class="btn btn-success" @click="gravar" v-show="habilitaGravar && !gravando" >
        <i class="fa fa-check">  Gravar</i>
      </button>
      <button v-show="gravando" class="btn btn-success"><i class="fa fa-spinner fa-spin"></i>  Gravando</button>
      </div>
    </box>
  </section>
</template>

<script>
import resource from './resource';
import resourceServicos from '../Servicos/resource'
import Box from '../Box'
import { MultiSelect } from 'vue-search-select'
import _ from 'lodash'
import s3 from '../../../services/s3'
import { setTimeout } from 'timers';

export default {
  components: {
    'box': Box,
    MultiSelect
  },
  data: () => ({
    lastSelectItem: {},
    dialog: false,
    loading: false,
    dialogErro: false,
    erro: false,
    servicos: [],
    alteracao: false,
    idEditar: 0,
    pergunta: {
      descricao: '',
      tipo: '',
      posicao: 0,
      ativo: true,
      opcoes: [{
        opcao : '',
      }]
    },
    ativo: false,
    gravando: false
  }),
  created() {
    if(this.$route.params.id) {
      console.log('alterando');
      this.alteracao = true
      this.idEditar = this.$route.params.id
      this.getPergunta(this.idEditar)
    }
  },
  computed: {
    nome: function () {
      if(this.alteracao) return 'alteracao Funcionário'
      else return 'Novo Funcionário'
    },
    habilitaGravar: function() {
      return this.pergunta.descricao 
    }
  },
  methods: {
    onSelect (items, lastSelectItem) {
      this.pergunta.funcao = items
      this.lastSelectItem = lastSelectItem
      setTimeout(function(){ 
          $('.delete').removeClass('detele').addClass('fa fa-trash');
      }, 100);
    },
    // deselect option
    adicionarOpcao() {
        console.log('adicionar')
      this.pergunta.opcoes.push({ opcao: '' })
    },
    removerOpcao(index) {
      this.pergunta.opcoes.splice(index, 1)
    },
    reset () {
      this.items = [] // reset
    },
    // select option from parent component
    selectFromParentComponent () {
      this.items = _.unionWith(this.items, [this.options[0]], _.isEqual)
    },
    gravar () {
      this.gravando = true
      if (this.pergunta.tipo === 'card') {
        let files = this.pergunta.opcoes.map((element, index) => document.getElementById(`file-pergunta-${index}`).files[0] );
        files = files.filter(function (el) {
          return el != null && el != undefined;
        });
        console.log('files => ', files)
        if(files.length > 0 ) {
          files.forEach((file, index) => {
            s3.getSignedRequest(file).then(res => {
              this.pergunta.opcoes[index].imagem = res.url;
            }).catch(err => {
              console.log('erro => ', err);
              this.erro = true;
              alert('Erro ao salvar imagem');
            })
          });
        }

        setTimeout(() => {
          if(!this.erro) {
            this.submit();
          }
        }, files.length * 1500)
      } else {
        this.submit();
      }
    },
    async submit() {
      console.log('gravar => ', this.pergunta);
      if(this.alteracao) {
        resource.atualizaPergunta(this.pergunta, this.idEditar).then((res) => {
          this.$swal({
              position: 'top-end',
              type: 'success',
              title: 'Incluido com sucesso',
              showConfirmButton: false,
              timer: 1500
            })   
          this.$router.go(-1)
        }).catch(err => {
          this.$swal(
            'Ops!',
            'O Pergunta não foi gravado.',
            'error'
          )
        })
      } else {
        resource.gravarPergunta(this.pergunta).then((res) => {
          this.$swal({
              position: 'top-end',
              type: 'success',
              title: 'Incluido com sucesso',
              showConfirmButton: false,
              timer: 1500
            })   
          this.$router.go(-1)
        }).catch(err => {
          this.$swal(
            'Ops!',
            'O Pergunta não foi gravado.',
            'error'
          )
        })
      }
    },
    getPergunta() {
      resource.getPergunta(this.idEditar).then((res) => {
        let data = res.data
        this.pergunta = {
          descricao: data.pergunta,
          tipo: data.tipo,
          posicao: data.posicao,
          ativo: data.ativo,
          opcoes: [{
              opcao: ''
          }]
        };
        if(data.tipo === 'options') {
            this.pergunta.opcoes = data.OpcoesPerguntas.map(opcao => ({
                opcao : opcao.opcao,
            })) 
        }
        console.log('pergunta => ', this.pergunta)
        setTimeout(function(){ 
            $('.delete').removeClass('detele').addClass('fa fa-trash');
        }, 100);
      });
    },
    close() {
      this.setFuncionarioNull()
      this.dialog = false; 
      this.$emit('close');
    },
    setFuncionarioNull() {
      this.debito = {
        qtde_parcelas: null,
        honorarios: null,
        url_documento: null,
        total_debito: null,
        parcelas: [{
          data_vencimento: null,
          valor: null,
          juros: null,
          correcao: null,
        }],
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// novaPergunta.vue?2e0cc8c1